var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H120V120H0V0ZM26.0869 44.3479H15.6521V97.5062L26.0869 106.957V44.3479ZM70.1449 82.8016H87.3427C86.3981 85.1274 85.0629 87.2987 83.3748 89.2117C79.754 93.3172 74.7593 95.9591 69.3282 96.6432C63.8972 97.3272 58.4035 96.0051 53.8782 92.9245C49.353 89.845 46.1076 85.2194 44.7509 79.9167C43.3944 74.6129 44.0201 68.9977 46.5106 64.1232C49.0011 59.2487 53.1853 55.451 58.2774 53.4425C63.3696 51.4351 69.0196 51.3538 74.1669 53.216C79.3142 55.0783 83.6048 58.7557 86.2333 63.5571L95.125 58.6897C91.3108 51.7217 85.0848 46.3861 77.6155 43.684C70.1463 40.982 61.9475 41.0988 54.5584 44.0131C47.1692 46.9274 41.0978 52.4376 37.4838 59.5117C33.8697 66.5847 32.9619 74.7332 34.9303 82.4289C36.8988 90.1234 41.6084 96.8354 48.1748 101.305C54.7414 105.774 62.7134 107.693 70.5943 106.701C78.475 105.708 85.7229 101.874 90.9771 95.9178C95.9255 90.3074 98.785 83.1778 99.1011 75.731L99.1304 75.5553V73.1398H79.4204L70.1449 82.8016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.84d2323ae20382c84e0732b0ea8df371.svg";
export { ForwardRef as ReactComponent };